
















































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Question, Answer, SurveyType, SurveySection } from "@/interfaces";

import { AuthModule, SurveyModule } from "@/store";
import { notifyError } from "@/common/notify";
import { extractFromString } from "@/common/utils";

Component.registerHooks(["beforeRouteLeave"]);

@Component({
  components: {
    SurveyFields: () => import("@/components/SurveyFields.vue"),
  },
})
export default class Survey extends Vue {
  @SurveyModule.bindings.State
  questions!: Question[];

  @SurveyModule.bindings.State
  allQuestions!: Question[];

  @SurveyModule.bindings.State
  questionsGrouped!: { [key: number]: Question[] };

  @SurveyModule.bindings.State
  currentPage!: number;

  @SurveyModule.bindings.State
  loading!: boolean;

  @SurveyModule.bindings.State
  completing!: boolean;

  @AuthModule.bindings.State
  loadingStatus!: boolean;

  @SurveyModule.bindings.Getter
  visibleSection!: SurveySection;

  @SurveyModule.bindings.Getter
  sectionsCount!: number;

  @SurveyModule.bindings.Getter
  valueFromDictionaries!: (dictName: string, searchedValue: string, returnValue: string) => string;

  @SurveyModule.bindings.State
  currentSection!: number;

  @SurveyModule.bindings.State
  type!: SurveyType;

  @AuthModule.bindings.Getter
  isAdministrator!: boolean;

  @SurveyModule.bindings.State
  canExit!: boolean;

  error: any = null;

  @Watch("$route")
  async onRouteParameterChange() {
    try {
      await SurveyModule.store.reset();
      this.surveySetup();
    } catch (err) {
      this.error = err;
      console.log(err);
    }
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (to.name !== "login" && !this.canExit && this.error === null) {
      this.$q
        .dialog({
          title: "Attenzione",
          message: "Sei sicuro di voler lasciare il sondaggio? Le modifiche non salvate andranno perse!",
          html: true,
          cancel: true,
        })
        .onOk(() => {
          next();
        });
    } else {
      next();
    }
  }

  mounted() {
    window.addEventListener("beforeunload", this.onWindowClose);
    this.surveySetup();
  }

  async surveySetup() {
    try {
      if (this.$route.params.surveyId) {
        const actionType = this.$route.params.actionType;
        await SurveyModule.store.getSurveyByID({
          type: this.$route.params.type as SurveyType,
          id: this.$route.params.surveyId,
          actionType,
        });
      } else {
        await SurveyModule.store.getSurvey(this.$route.params.type as SurveyType);
      }
    } catch (err) {
      this.error = err;
      console.log(err.response);
      if (err.response && err.response.data && err.response.data.error) {
        notifyError(err.response.data.error);
      } else {
        notifyError("Errore imprevisto, riprova più tardi!");
      }
      this.$router.push("/dashboard");
    }
  }

  onWindowClose(event: any) {
    event.preventDefault();
    event.returnValue = "Sei sicuro di voler lasciare il sondaggio? Le modifiche non salvate andranno perse!";
  }

  async beforeDestroy() {
    window.removeEventListener("beforeunload", this.onWindowClose);
    try {
      await SurveyModule.store.reset();
    } catch (err) {
      console.log(err);
    }
  }

  onAnswersChange(answers: Answer[]) {
    SurveyModule.store.setNewAnswers(answers);
  }

  goToMacroProductSurvey() {
    this.$router.push(`/survey/${SurveyType.MACRO_PRODUCT}`).catch(error => console.log(error));
  }

  onTermClick(term: string) {
    SurveyModule.store.setScrollToTerm(term);
  }

  get breadcrumb() {
    switch (this.type) {
      case SurveyType.GOVERNANCE:
        return [
          {
            label: "governance dell'ambito",
            to: "/governance",
          },
          {
            label: "descrizione",
          },
        ];
      case SurveyType.PRODUCT:
        return [
          {
            label: "prodotti e mercati",
            to: "/products-markets",
          },
          {
            label: "prodotti",
            to: "/product",
          },
          {
            label: this.$route.params.surveyId
              ? "Modifica prodotto turistico dell'Ambito"
              : "Aggiungi prodotto turistico dell'Ambito",
          },
        ];
      case SurveyType.MACRO_PRODUCT:
        if (this.isAdministrator) {
          return [
            {
              label: "gestione prodotti turistici",
              to: "/macro-products-management",
            },
            {
              label: this.$route.params.surveyId ? "modifica prodotto turistico" : "aggiungi nuovo prodotto turistico",
            },
          ];
        } else {
          return [
            {
              label: "prodotti e mercati",
              to: "/products-markets",
            },
            {
              label: "prodotti",
              to: "/product",
            },
            {
              label: this.$route.params.surveyId ? "modifica prodotto turistico" : "Proponi nuovo prodotto turistico",
            },
          ];
        }
      case SurveyType.ATTRACTION:
        return [
          {
            label: "prodotti e mercati",
            to: "/products-markets",
          },
          {
            label: "attrattori",
            to: "/attractors",
          },
          {
            label: this.$route.params.surveyId ? "modifica attrattore" : "aggiungi attrattore",
          },
        ];
      case SurveyType.MARKET:
        return [
          {
            label: "prodotti e mercati",
            to: "/products-markets",
          },
          {
            label: "mercati",
            to: "/markets",
          },
          {
            label: this.$route.params.surveyId ? "modifica mercato" : "aggiungi mercato",
          },
        ];
      case SurveyType.ANALYSIS_ATTRACTION:
        return [
          {
            label: "Management delle destinazioni",
            to: "/management",
          },
          {
            label: "Attrattività",
            to: "/management-attractiveness",
          },
          {
            label: "Analisi",
            to: "/analysis-attractiveness",
          },
          {
            label: "Attrattori",
          },
        ];
      case SurveyType.INITIATIVE_VALIDATED:
        if (this.isAdministrator) {
          return [
            {
              label: "Gestione Ambiti Territoriali",
              to: "/management-territorial-areas",
            },
            {
              label: "Validazione Iniziative",
              to: "/iniziative-validations",
            },
            {
              label: "Stato progetto",
            },
          ];
        }

        return [
          {
            label: "Obiettivi, Iniziative e Progetti",
            to: "/environment-plan",
          },
          {
            label: "Iniziative Validate e Progetti",
            to: "/iniziative-validations",
          },
          {
            label: "Stato progetto",
          },
        ];
      case SurveyType.ANALYSIS_OLDTOWN:
        return [
          {
            label: "Management delle destinazioni",
            to: "/management",
          },
          {
            label: "Attrattività",
            to: "/management-attractiveness",
          },
          {
            label: "Analisi",
            to: "/analysis-historical-centres",
          },
          {
            label: "Centri Storici",
          },
        ];
      case SurveyType.STRATEGY_ATTRACTION:
        return [
          {
            label: "Management delle destinazioni",
            to: "/management",
          },
          {
            label: "Attrattività",
            to: "/management-attractiveness",
          },
          {
            label: "Strategie",
            to: "/attraction-strategies",
          },
          {
            label: "Obiettivo",
          },
        ];
      case SurveyType.INITIATIVE_ATTRACTION:
        if (this.isAdministrator) {
          return [
            {
              label: "Gestione Ambiti Territoriali",
              to: "/management-territorial-areas",
            },
            {
              label: "Validazione Iniziative",
              to: "/iniziative-validations",
            },
            {
              label: "Iniziativa",
            },
          ];
        }

        return [
          {
            label: "Management delle destinazioni",
            to: "/management",
          },
          {
            label: "Attrattività",
            to: "/management-attractiveness",
          },
          {
            label: "Iniziative",
            to: "/attraction-initiative",
          },
          {
            label: "Iniziativa",
          },
        ];
      case SurveyType.ANALYSIS_ACCESSIBILITY:
        return [
          {
            label: "Management delle destinazioni",
            to: "/management",
          },
          {
            label: "Accesso alla destinazioni",
            to: "/management-destination-access",
          },
          {
            label: "Analisi",
          },
        ];
      case SurveyType.STRATEGY_ACCESSIBILITY:
        return [
          {
            label: "Management delle destinazioni",
            to: "/management",
          },
          {
            label: "Accesso alla destinazioni",
            to: "/management-destination-access",
          },
          {
            label: "Strategie",
            to: "/accessibility-strategies",
          },
          {
            label: "Obiettivo",
          },
        ];
      case SurveyType.INITIATIVE_ACCESSIBILITY:
        if (this.isAdministrator) {
          return [
            {
              label: "Gestione Ambiti Territoriali",
              to: "/management-territorial-areas",
            },
            {
              label: "Validazione Iniziative",
              to: "/iniziative-validations",
            },
            {
              label: "Iniziativa",
            },
          ];
        }

        return [
          {
            label: "Management delle destinazioni",
            to: "/management",
          },
          {
            label: "Accesso alla destinazioni",
            to: "/management-destination-access",
          },
          {
            label: "Iniziative",
            to: "/accessibility-initiative",
          },
          {
            label: "Iniziativa",
          },
        ];
      case SurveyType.ANALYSIS_HOSPITALITY:
        return [
          {
            label: "Management delle destinazioni",
            to: "/management",
          },
          {
            label: "Accoglienza",
            to: "/management-hospitality",
          },
          {
            label: "Situazione dell'accoglienza",
          },
        ];
      case SurveyType.INITIATIVE_HOSPITALITY:
        if (this.isAdministrator) {
          return [
            {
              label: "Gestione Ambiti Territoriali",
              to: "/management-territorial-areas",
            },
            {
              label: "Validazione Iniziative",
              to: "/iniziative-validations",
            },
            {
              label: "Iniziativa",
            },
          ];
        }

        return [
          {
            label: "Management delle destinazioni",
            to: "/management",
          },
          {
            label: "Accoglienza",
            to: "/management-hospitality",
          },
          {
            label: "Iniziative",
            to: "/hospitality-initiative",
          },
          {
            label: "Iniziativa",
          },
        ];
      case SurveyType.STRATEGY_HOSPITALITY:
        return [
          {
            label: "Management delle destinazioni",
            to: "/management",
          },
          {
            label: "Accoglienza",
            to: "/management-hospitality",
          },
          {
            label: "Strategie",
            to: "/hospitality-strategies",
          },
          {
            label: "Obiettivo",
          },
        ];
      case SurveyType.INFOPOINT:
        return [
          {
            label: "Management delle destinazioni",
            to: "/management",
          },
          {
            label: "Accoglienza",
            to: "/management-hospitality",
          },
          {
            label: "Punti Informativi",
            to: "/hospitality-infopoint",
          },
          {
            label: "Punto Informativo",
          },
        ];
      case SurveyType.BRAND:
        return [
          {
            label: "Promozione delle destinazioni",
            to: "/promotion",
          },
          {
            label: "Analisi brand e distribuzione",
            to: "/promotion-brand-equity",
          },
          {
            label: "Brand Equity",
          },
        ];
      case SurveyType.ANALYSIS_PLANNING:
        return [
          {
            label: "Promozione delle destinazioni",
            to: "/promotion",
          },
          {
            label: "Scelta dei canali informativi e distributivi",
            to: "/promotion-trip-planning",
          },
          {
            label: "Canali",
          },
        ];
      case SurveyType.ANALYSIS_POSITIONING:
        return [
          {
            label: "Promozione delle destinazioni",
            to: "/promotion",
          },
          {
            label: "Analisi dei canali informativi e distributivi",
            to: "/promotion-channel-positioning",
          },
          {
            label: "Analisi",
          },
        ];
      case SurveyType.STRATEGY_AWARENESS:
        return [
          {
            label: "Promozione delle destinazioni",
            to: "/promotion",
          },
          {
            label: "Affermazione dei brand",
            to: "/promotion-strategy-awareness",
          },
          {
            label: "Strategie",
          },
        ];
      case SurveyType.INITIATIVE_AWARENESS:
        if (this.isAdministrator) {
          return [
            {
              label: "Gestione Ambiti Territoriali",
              to: "/management-territorial-areas",
            },
            {
              label: "Validazione Iniziative",
              to: "/iniziative-validations",
            },
            {
              label: "Iniziativa",
            },
          ];
        }

        return [
          {
            label: "Promozione delle destinazioni",
            to: "/promotion",
          },
          {
            label: "Affermazione dei brand",
            to: "/promotion-initiative-awareness",
          },
          {
            label: "Iniziative",
          },
        ];
      case SurveyType.STRATEGY_VISIBILITY:
        return [
          {
            label: "Promozione delle destinazioni",
            to: "/promotion",
          },
          {
            label: "ACQUISTABILITÀ E VISIBILITÀ DELL'OFFERTA",
            to: "/promotion-strategy-visibility",
          },
          {
            label: "Strategie",
          },
        ];
      case SurveyType.INITIATIVE_VISIBILITY:
        if (this.isAdministrator) {
          return [
            {
              label: "Gestione Ambiti Territoriali",
              to: "/management-territorial-areas",
            },
            {
              label: "Validazione Iniziative",
              to: "/iniziative-validations",
            },
            {
              label: "Iniziativa",
            },
          ];
        }

        return [
          {
            label: "Promozione delle destinazioni",
            to: "/promotion",
          },
          {
            label: "ACQUISTABILITÀ E VISIBILITÀ DELL'OFFERTA",
            to: "/promotion-initiative-visibility",
          },
          {
            label: "Iniziative",
          },
        ];
      case SurveyType.USER_STRATEGY:
        return [
          {
            label: "Piano d'ambito",
            to: "/ambit-plan",
          },
          {
            label: "Riassunto strategia",
            to: "/strategy-summary",
          },
          {
            label: "Strategia",
          },
        ];
      case SurveyType.MERGE_MACROPRODUCTS:
        return [
          {
            label: "Gestione Prodotti Turistici",
            to: "/macro-products-management",
          },
          {
            label: "Unifica Prodotti",
          },
        ];
    }
    return [];
  }

  get answers() {
    return SurveyModule.store.answers;
  }

  set answers(answers: Answer[]) {
    SurveyModule.store.setAnswers(answers);
  }

  getSectionSubtitleParse(subtitle: string) {
    let editedSubtitle = subtitle;
    if (editedSubtitle.includes("{")) {
      const termsToReplace = extractFromString(editedSubtitle, "{", "}");

      termsToReplace.forEach((termToReplace: string) => {
        const splittedTerm = termToReplace.split("/");
        const answerBindID = splittedTerm[0].replace("bind.", "");
        const dictInfo = splittedTerm[1].split(".");
        const dictName = dictInfo[0];
        const valueToGet = dictInfo[1];

        const answer = this.answers.find(ans => ans.id === answerBindID);

        if (answer && answer.answer) {
          const valueFromDict = this.valueFromDictionaries(dictName, answer.answer, valueToGet);

          editedSubtitle = editedSubtitle.replace(`{${termToReplace}}`, valueFromDict);
        } else {
          editedSubtitle = editedSubtitle.replace(`{${termToReplace}}`, "Non trovato");
        }
      });
    }

    return editedSubtitle;
  }
}
